import React from "react";
import { Tone } from "../../model/core";
import _ from "lodash";


export function RydToneSelector({
    centerChanged,
    center,
    buttonCSS
}: {
    centerChanged: (tone: Tone | undefined) => void,
    center?: Tone,
    buttonCSS: (b: boolean) => string
}) {
    return (<div>
        <label>Center</label>
        <ul className='midi-device-panel--list'>
            <li onClick={() => centerChanged(undefined)}>---</li>
            {Tone.all()
                .map((tone, i) =>
                    <li key={i} value={tone.getName()}
                        className={buttonCSS(tone.index === center?.index)}
                        onClick={() => centerChanged(tone)} >
                        {tone.getName()}
                    </li>
                )}
        </ul>
    </div>);
}